<template>
  <v-container fluid class="px-0" id="listado-borradores">

    <v-card class="mb-2" elevation="0">
      <!-- Barra bulk — siempre visible -->
      <div class="bulk-action-bar" :class="{ 'bulk-action-bar--active': selectedIds.length > 0 }">
        <span class="bulk-label">
          <template v-if="selectedIds.length > 0">
            {{ selectedIds.length }} borrador{{ selectedIds.length !== 1 ? 'es' : '' }} seleccionado{{ selectedIds.length !== 1 ? 's' : '' }}
          </template>
          <template v-else>
            Selecciona borradores para eliminar
          </template>
        </span>
        <v-btn text x-small class="bulk-clear-btn" :disabled="selectedIds.length === 0" @click="clearSelection">
          Limpiar
        </v-btn>
        <v-btn x-small class="bulk-delete-btn" :disabled="selectedIds.length === 0" @click="deleteBulk">
          <v-icon x-small class="mr-1">mdi-delete-outline</v-icon>
          Eliminar seleccionados
        </v-btn>
      </div>
			<!-- Filtro Compartidos conmigo -->
			<div class="col-shared-filter">
				<v-btn
					x-small
					depressed
					:class="['shared-filter-btn', { 'shared-filter-btn--active': showLocalDrafts }]"
					@click="toggleLocalDrafts"
				>
					<v-icon x-small class="mr-1">{{ showLocalDrafts ? 'mdi-cloud-off' : 'mdi-cloud-off-outline' }}</v-icon>
					<span class="hidden-xs-only">Creados Sin conexión</span>
					<span class="hidden-sm-and-up">Local</span>
				</v-btn>
				<v-btn
					x-small
					depressed
					:class="['shared-filter-btn', { 'shared-filter-btn--active': sharedWithMe }]"
					@click="toggleSharedWithMe"
				>
					<v-icon x-small class="mr-1">{{ sharedWithMe ? 'mdi-account-multiple-check' : 'mdi-account-multiple-outline' }}</v-icon>
					<span class="hidden-xs-only">Compartidos conmigo</span>
					<span class="hidden-sm-and-up">Conmigo</span>
				</v-btn>
			</div>

      <!-- Cabecera columnas -->
      <v-card-text class="header-table-card py-2">
        <div class="col-headers-row">
          <div class="col-check" v-if="!sharedWithMe">
            <v-simple-checkbox
              :value="allSelected"
              :indeterminate="someSelected"
              color="#2D4B95"
              @input="toggleAll"
              class="mt-0 pt-0"
              hide-details
            ></v-simple-checkbox>
          </div>
          <div class="col-borrador">
            <p class="mb-0 font-weight-bold body-2 text-capitalize text--secondary">Borrador</p>
          </div>
          <div class="col-creador" v-if="!isMobile">
            <p class="mb-0 font-weight-bold body-2 text-capitalize text--secondary">Creador</p>
          </div>
          <div class="col-fecha" v-if="!isMobile">
            <v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" style="height: auto;" @click="toggleOrder">
              <v-icon color="#5e85ef" small class="mr-1">{{ getIconOrder() }}</v-icon>
              <p class="mb-0 font-weight-bold body-2 text-capitalize">Fecha de Creación</p>
            </v-btn>
          </div>
          <div class="col-fecha-mobile" v-if="isMobile">
            <v-btn text class="table-header-button d-flex flex-row pa-0 justify-end" style="height: auto;" @click="toggleOrder">
              <v-icon color="#5e85ef" small class="mr-1">{{ getIconOrder() }}</v-icon>
              <p class="mb-0 font-weight-bold body-2 text-capitalize">Fecha</p>
            </v-btn>
          </div>
          <div class="col-action"></div>
        </div>
      </v-card-text>
      <v-progress-linear
        v-if="loading"
        class="listing-loading-bar"
        indeterminate
        color="#5e85ef"
      ></v-progress-linear>
    </v-card>

    <!-- Lista -->
    <div v-if="!loading && activeDrafts.length > 0" class="listing-scroll">
      <v-card
        class="draft-card mb-2"
        v-for="(draft, index) in activeDrafts"
        :key="index"
        :class="{ 'draft-card--selected': selectedIds.includes(draft.id) }"
        style="overflow: hidden;"
        @click="selectDraft(draft)"
      >
        <v-card-text class="py-2 px-3">

          <!-- DESKTOP -->
          <div v-if="!isMobile" class="draft-row">
            <div class="col-check" v-if="!sharedWithMe" @click.stop>
              <v-simple-checkbox
                :value="selectedIds.includes(draft.id)"
                color="#2D4B95"
                @input="toggleSelect(draft.id)"
                class="mt-0 pt-0"
                hide-details
              ></v-simple-checkbox>
            </div>
            <div class="col-borrador">
              <p class="mb-0 caption text--disabled font-weight-bold">{{ getTypeText(draft) }}</p>
              <p class="mb-0 font-weight-bold body-2 text-primary-color" style="word-break: break-word;">{{ getTitleFromDraft(draft) }}</p>
            </div>
            <div class="col-creador">
              <p class="mb-0 body-2 text--secondary">{{ draft.user?.name || '--' }}</p>
              <p class="mb-0 font-weight-bold body-2 text-primary-color">{{ draft.user?.email || '--' }}</p>
            </div>
            <div class="col-fecha">
              <p class="mb-0 font-weight-bold body-2 text-primary-color">{{ draft.created_at | toDateTime }}</p>
            </div>
            <div class="col-action">
              <!-- Share button with dropdown -->
              <v-menu offset-y left :close-on-content-click="false" max-width="300" v-if="draft.created_by == userInfo.id && !showLocalDrafts">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
                    <v-icon :color="draft.shares && draft.shares.length > 0 ? '#2D4B95' : '#5e85ef'" small>mdi-share-variant</v-icon>
                    <!-- Badge si hay shares -->
                    <span v-if="draft.shares && draft.shares.length > 0" class="share-badge">{{ draft.shares.length }}</span>
                  </v-btn>
                </template>
                <v-card class="share-dropdown-card" elevation="4">
                  <div class="share-dropdown-header">
                    <v-icon small color="#5e85ef" class="mr-2">mdi-account-multiple</v-icon>
                    <span class="share-dropdown-title">Compartido con</span>
                    <v-chip x-small class="ml-auto share-count-chip" v-if="draft.shares && draft.shares.length > 0">
                      {{ draft.shares.length }}
                    </v-chip>
                  </div>

                  <div class="share-dropdown-body">
                    <template v-if="draft.shares && draft.shares.length > 0">
                      <div
                        v-for="share in draft.shares"
                        :key="share.id"
                        class="share-user-item"
                      >
                        <div class="share-user-avatar">{{ getInitials(share.user.name) }}</div>
                        <div class="share-user-info">
                          <p class="share-user-name">{{ share.user.name }}</p>
                          <p class="share-user-email">{{ share.user.email }}</p>
                        </div>
                        <v-btn icon x-small class="share-remove-btn" @click.stop="handleRemoveUserShared(draft.id, share.user.id)">
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <div v-else class="share-empty-state">
                      <v-icon color="#c5d3f0" size="28">mdi-account-off-outline</v-icon>
                      <p class="share-empty-text">Sin usuarios compartidos</p>
                    </div>
                  </div>

                  <div class="share-dropdown-footer">
                    <v-btn small depressed block class="share-add-btn" @click.stop="openShareModal(draft)">
                      <v-icon small class="mr-1">mdi-account-plus-outline</v-icon>
                      Agregar usuarios
                    </v-btn>
                  </div>
                </v-card>
              </v-menu>

              <!-- Delete button -->
              <v-btn icon small @click.stop="startDeleteDraftItem(draft)">
                <v-icon color="#e04f4f" small>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- MÓVIL -->
          <div v-else class="draft-row-mobile">
            <div class="mobile-check" @click.stop>
              <v-simple-checkbox
                :value="selectedIds.includes(draft.id)"
                color="#2D4B95"
                @input="toggleSelect(draft.id)"
                class="mt-0 pt-0"
                hide-details
              ></v-simple-checkbox>
            </div>
            <div class="mobile-content">
              <p class="mb-0 caption text--disabled font-weight-bold mobile-type">{{ getTypeText(draft) }}</p>
              <p class="mb-0 font-weight-bold body-2 text-primary-color mobile-title">{{ getTitleFromDraft(draft) }}</p>
              <div class="mobile-meta">
                <span class="caption text--secondary">{{ draft.user.name }}</span>
                <span class="caption mobile-dot">·</span>
                <span class="caption font-weight-bold text-primary-color">{{ draft.created_at | toDateTime }}</span>
              </div>
            </div>
            <div class="mobile-action">
              <v-menu offset-y left :close-on-content-click="false" max-width="270" v-if="draft.created_by == userInfo.id">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-bind="attrs" v-on="on" @click.stop style="position:relative;">
                    <v-icon x-small :color="draft.shares && draft.shares.length > 0 ? '#2D4B95' : '#5e85ef'">mdi-share-variant</v-icon>
                    <span v-if="draft.shares && draft.shares.length > 0" class="share-badge share-badge--mobile">{{ draft.shares.length }}</span>
                  </v-btn>
                </template>
                <v-card class="share-dropdown-card" elevation="4">
                  <div class="share-dropdown-header">
                    <v-icon small color="#5e85ef" class="mr-2">mdi-account-multiple</v-icon>
                    <span class="share-dropdown-title">Compartido con</span>
                    <v-chip x-small class="ml-auto share-count-chip" v-if="draft.shares && draft.shares.length > 0">
                      {{ draft.shares.length }}
                    </v-chip>
                  </div>
                  <div class="share-dropdown-body">
                    <template v-if="draft.shares && draft.shares.length > 0">
                      <div
                        v-for="share in draft.shares"
                        :key="share.id"
                        class="share-user-item"
                      >
                        <div class="share-user-avatar share-user-avatar--sm">{{ getInitials(share.user.name) }}</div>
                        <div class="share-user-info">
                          <p class="share-user-name">{{ share.user.name }}</p>
                          <p class="share-user-email">{{ share.user.email }}</p>
                        </div>
                        <v-btn icon x-small class="share-remove-btn" @click.stop="handleRemoveUserShared(draft.id, share.user.id)">
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <div v-else class="share-empty-state">
                      <v-icon color="#c5d3f0" size="24">mdi-account-off-outline</v-icon>
                      <p class="share-empty-text">Sin usuarios compartidos</p>
                    </div>
                  </div>
                  <div class="share-dropdown-footer">
                    <v-btn small depressed block class="share-add-btn" @click.stop="openShareModal(draft)">
                      <v-icon small class="mr-1">mdi-account-plus-outline</v-icon>
                      Agregar
                    </v-btn>
                  </div>
                </v-card>
              </v-menu>

              <v-btn icon x-small @click.stop="startDeleteDraftItem(draft)">
                <v-icon x-small color="#e04f4f">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

        </v-card-text>
      </v-card>

      <v-row align="center" v-if="Math.ceil(totalDrafts / 50) > 1">
        <v-col cols="12">
          <v-pagination
            v-model="page"
            color="#2D4B95"
            :length="Math.ceil(totalDrafts / 50)"
            :total-visible="7"
            @input="changePage"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>

    <!-- Empty state -->
    <div v-else-if="!loading && activeDrafts.length === 0">
      <v-card class="mb-2 py-8" elevation="0">
        <v-card-text class="text-center">
          <v-icon color="#c5d3f0" size="40" class="mb-3">
            {{ sharedWithMe ? 'mdi-account-multiple-outline' : 'mdi-file-document-outline' }}
          </v-icon>
          <p class="mb-0 body-2 text--secondary">
            {{ sharedWithMe ? 'No hay borradores compartidos contigo' : 'No hay borradores creados' }}
          </p>
        </v-card-text>
      </v-card>
    </div>

    <!-- Skeleton -->
    <div v-else>
      <v-card class="mb-2 py-2" elevation="0" v-for="i in 5" :key="i">
        <v-card-text class="py-2">
          <v-row>
            <v-col cols="5"><v-skeleton-loader min-width="100%" type="list-item"></v-skeleton-loader></v-col>
            <v-col cols="4"><v-skeleton-loader min-width="100%" type="list-item"></v-skeleton-loader></v-col>
            <v-col cols="3"><v-skeleton-loader min-width="100%" type="list-item"></v-skeleton-loader></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- Share Draft Modal -->
    <ShareDraftModal
      :visible="shareModalVisible"
      :draft="draftBeingShared"
      @close="closeShareModal"
      @confirm="handleShareDraft"
    />

  </v-container>
</template>

<script>
import EventBus from '@/helpers/event_bus'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'
import { getDraftsByProjectID, getDraftByID, deleteDraft, shareDraft, removeUserShared } from '@/helpers/api/drafts'
import ShareDraftModal from '@/components/Globals/Modals/Drafts/ShareDraftModal.vue'

export default {
  name: 'ListadoBorradores',
  components: { ShareDraftModal },
  props: {
    draftType: { type: Number, default: 1 }
  },
  computed: {
    isMobile() { return this.$vuetify.breakpoint.mobile },
    allSelected() { return this.drafts.length > 0 && this.selectedIds.length === this.drafts.length },
    someSelected() { return this.selectedIds.length > 0 && this.selectedIds.length < this.drafts.length },
    selectedProject() { return this.$store.projectsStore.state.selectedProject },
		userInfo(){
			return this.$store.userStore.state.userInfo
		},
		activeDrafts() {
			return this.showLocalDrafts ? this.localDrafts : this.drafts
		},
  },
	watch: {
    selectedProject(newVal, oldVal) {
      if (newVal?.id === oldVal?.id) return
      this.drafts = []
      this.localDrafts = []
      this.totalDrafts = 0
      this.selectedIds = []
      this.page = 1
      if (newVal?.id) this.reloadList()
    },
		showLocalDrafts(newVal) {
			if (newVal) this.sharedWithMe = false
		},
		sharedWithMe(newVal) {
			if (newVal) this.showLocalDrafts = false
			else{
				this.getDraftsList()
			}
		}
	},
  data: () => ({
    loading: false,
		showLocalDrafts: false,
    drafts: [],
    localDrafts: [],
    totalDrafts: 0,
    page: 1,
    listingOrder: 1,
    selectedIds: [],
    shareModalVisible: false,
    draftBeingShared: null,
    sharedWithMe: false,
  }),
  mounted() {
		this.reloadList()
    EventBus.$on('reloadDraftList', this.reloadList)
  },
  beforeDestroy() {
    EventBus.$off('reloadDraftList')
  },
  methods: {
		reloadList() {
			this.getDraftsList()
			this.getLocalDrafts()
		},
		toggleLocalDrafts() {
			this.showLocalDrafts = !this.showLocalDrafts
			this.clearSelection()
		},
    parseData(draft) {
      if (draft.data && typeof draft.data === 'string') {
        try { draft.data = JSON.parse(draft.data) } catch (e) { draft.data = {} }
      }
      return draft
    },
    getTypeText(draft) {
      const types = {
        1: 'Borrador para Tarea', 2: 'Borrador para RDI', 3: 'Borrador para Adicional',
        4: 'Borrador para Posible Adicional', 5: 'Borrador para Interacción de Tarea',
        6: 'Borrador para Interacción de RDI', 7: 'Borrador para Interacción de Adicional',
        8: 'Borrador para Interacción de Posible Adicional', 9: 'Borrador para Entrega',
        10: 'Borrador para Observación de Adicional', 11: 'Borrador para Aprobación Entrega',
				12: 'Borrador para Aprobación Entrega (Carga Masiva)',
				13: 'Borrador para Reunión/Minuta', 14: 'Borrador para Interacción de Reunión/Minuta'
      }
      return types[draft.raw_type] || 'Sin tipo'
    },
    getTitleFromDraft(draft) {
      if (!draft.data) return 'Sin título'
      const data = typeof draft.data === 'string' ? JSON.parse(draft.data) : draft.data
      if ([5, 6, 7, 8, 10].includes(draft.raw_type)) return `Nº${data?.number}: ${data?.title}`
      return data?.form?.title || 'Sin título'
    },
    getInitials(name) {
      if (!name) return '?'
      return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase()
    },
    async selectDraft(draft) {
			if(String(draft.id).startsWith('local_')){
				this.$emit('loadDraft', draft)
				return
			}
      const draftData = await getDraftByID({ id: draft.id })
      if (draftData.code === 200) {
        this.parseData(draftData.draft)
        this.$emit('loadDraft', draftData.draft)
      }
    },
    getIconOrder() { return this.listingOrder === 1 ? 'mdi-arrow-down-bold' : 'mdi-arrow-up-bold' },
    toggleOrder() {
      this.listingOrder = this.listingOrder === 1 ? 2 : 1
      this.page = 1
      this.getDraftsList()
    },
    // ── Nuevo: toggle filtro compartidos conmigo ──
    toggleSharedWithMe() {
      this.sharedWithMe = !this.sharedWithMe
      this.page = 1
      this.clearSelection()
      this.getDraftsList()
    },
    toggleSelect(id) {
      const idx = this.selectedIds.indexOf(id)
      if (idx === -1) this.selectedIds.push(id)
      else this.selectedIds.splice(idx, 1)
    },
    toggleAll() {
			if(this.showLocalDrafts){
				this.selectedIds = this.allSelected ? [] : this.localDrafts.map(d => d.id)
				return
			}
      this.selectedIds = this.allSelected ? [] : this.drafts.map(d => d.id)
    },
    clearSelection() { this.selectedIds = [] },
		startDeleteDraftItem(draft){
			const isLocal = String(draft.id).startsWith('local_')
			if(draft.created_by == this.userInfo.id || isLocal){
				this.deleteDraftItem(draft.id)
			}
			else{
				this.handleRemoveUserShared(draft.id, this.userInfo.id)
			}
		},
    async deleteDraftItem(draft_id) {
			const isLocal = String(draft_id).startsWith('local_')
			if(isLocal){
				this.deleteLocalDrafts([draft_id])
				return
			}
      await deleteDraft({ ids: [draft_id] })
      this.selectedIds = this.selectedIds.filter(id => id !== draft_id)
      this.getDraftsList()
    },
    async deleteBulk() {
			const localIds = this.selectedIds.filter(id => String(id).startsWith('local_'))
			const idsToDelete = this.selectedIds.filter(id => !String(id).startsWith('local_'))
			if(localIds.length > 0){
				this.deleteLocalDrafts(localIds)
			}
      this.selectedIds = []
			if(idsToDelete.length === 0) return

      await deleteDraft({ ids: [...idsToDelete] })
      this.getDraftsList()
    },
		deleteLocalDrafts(selectedIds = this.selectedIds) {
			[...selectedIds].forEach(id => {
				const idx = this.localDrafts.findIndex(d => d.id === id)
				if(idx !== -1) this.localDrafts.splice(idx, 1)
			})
			const localDrafts = this.localDrafts.map(d => ({ id: d.id, data: d.data, savedAt: new Date().toISOString() }))
			localStorage.setItem('pendingDrafts', JSON.stringify(localDrafts))
		},
		async getLocalDrafts() {
			const localDrafts = JSON.parse(localStorage.getItem('pendingDrafts') || '[]')
			if (localDrafts.length > 0) {
				this.localDrafts = localDrafts.filter(d => d.data?.type == this.draftType).map(d => ({...d.data, raw_type: d.data?.type})).map(d => this.parseData(d))
			}
    },
    async getDraftsList() {
      this.loading = true
      let project_id = this.$store.projectsStore.state.selectedProject?.id
        ?? parseInt(localStorage.getItem('selectedProjectID'))
      const request = getProjectRequest(project_id)
      if (project_id) {
        try {
          const response = await getDraftsByProjectID({
            project_id,
            type: this.draftType,
            page: this.page,
            order: this.listingOrder,
            shared_with_me: this.sharedWithMe,
          })
          if (isCurrentProjectRequest(request.projectId, request.generation) && response.code === 200) {
            this.drafts = (response.drafts || []).map(d => this.parseData(d))
            this.totalDrafts = response.total || 0
          }
        } catch (e) {
          if (isCurrentProjectRequest(request.projectId, request.generation)) {
            this.drafts = []
            this.totalDrafts = 0
          }
        }
      }
      if (isCurrentProjectRequest(request.projectId, request.generation)) this.loading = false
    },
    changePage() { this.getDraftsList() },
    openShareModal(draft) {
      this.draftBeingShared = draft
      this.shareModalVisible = true
    },
    closeShareModal() {
      this.shareModalVisible = false
      this.draftBeingShared = null
    },
    async handleShareDraft(userIds) {
      if (!this.draftBeingShared) return
      try {
        const response = await shareDraft({ id: this.draftBeingShared.id, user_ids: userIds })
        if (response.code === 200) {
          this.closeShareModal()
          this.getDraftsList()
        }
      } catch (error) {
        console.error('Error compartiendo borrador:', error)
      }
    },
    async handleRemoveUserShared(draftId, userId) {
      try {
        const response = await removeUserShared({ id: draftId, user_id: userId })
        if (response.code === 200) this.getDraftsList()
      } catch (error) {
        console.error('Error removiendo usuario compartido:', error)
      }
    },
  }
}
</script>

<style scoped>
#listado-borradores { align-self: stretch; }
.text-primary-color { color: #2D4B95; }
.listing-loading-bar { position: absolute; bottom: 0; }
.header-table-card { border: 1px solid white; }

/* ── Bulk bar ── */
.bulk-action-bar {
  display: flex; align-items: center; gap: 10px;
  padding: 7px 14px; background: #f0f4fb;
  border-radius: 8px 8px 0 0; border-bottom: 1px solid #e8edf8;
  transition: background 0.2s ease; min-height: 40px;
}
.bulk-action-bar--active { background: linear-gradient(90deg, #2D4B95, #4a6bc9); }
.bulk-label { flex: 1; font-size: 12px; font-weight: 600; color: #8898b3; transition: color 0.2s ease; }
.bulk-action-bar--active .bulk-label { color: white; }
.bulk-clear-btn { font-size: 11px !important; color: #aab4cc !important; }
.bulk-delete-btn {
  font-size: 11px !important; background: #e8edf8 !important;
  color: #aab4cc !important; border: 1px solid #dde3f0 !important;
}
.bulk-action-bar--active .bulk-clear-btn { color: rgba(255,255,255,0.8) !important; }
.bulk-action-bar--active .bulk-delete-btn {
  background: rgba(255,255,255,0.15) !important; color: white !important;
  border-color: rgba(255,255,255,0.3) !important;
}
.bulk-action-bar--active .bulk-delete-btn:hover { background: rgba(224,79,79,0.6) !important; }

/* ── Layout cabecera y filas ── */
.col-headers-row,
.draft-row {
  display: flex; align-items: center; gap: 8px; width: 100%;
}
.col-check         { width: 32px; flex-shrink: 0; }
.col-borrador      { flex: 5; min-width: 0; }
.col-creador       { flex: 4; min-width: 0; }
.col-fecha         { flex: 3; min-width: 0; }
.col-fecha-mobile  { margin-left: auto; }
.col-shared-filter {
  display: flex; align-items: center; justify-content: flex-end; gap: 10px;
  padding: 7px 14px; background: #f0f4fb;
  border-radius: 8px 8px 0 0; border-bottom: 1px solid #e8edf8;
  transition: background 0.2s ease; min-height: 40px;
}
.col-action        { width: 64px; flex-shrink: 0; display: flex; justify-content: flex-end; gap: 2px; }

/* ── Botón filtro "Compartidos conmigo" ── */
.shared-filter-btn {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: #8898b3 !important;
  background: #f0f4fb !important;
  border: 1.5px solid #dde3f0 !important;
  border-radius: 20px !important;
  text-transform: none !important;
  transition: all 0.2s ease !important;
  padding: 0 10px !important;
  height: 26px !important;
}
.shared-filter-btn--active {
  background: #eef1fb !important;
  border-color: #2D4B95 !important;
  color: #2D4B95 !important;
}
.shared-filter-btn--active .v-icon { color: #2D4B95 !important; }

/* ── Layout móvil ── */
.draft-row-mobile { display: flex; align-items: center; gap: 8px; width: 100%; }
.mobile-check   { width: 28px; flex-shrink: 0; }
.mobile-content { flex: 1; min-width: 0; }
.mobile-action  { width: 52px; flex-shrink: 0; display: flex; justify-content: flex-end; gap: 0; }
.mobile-type    { line-height: 1.2; margin-bottom: 1px !important; }
.mobile-title   { line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.mobile-meta    { display: flex; align-items: center; gap: 4px; flex-wrap: nowrap; margin-top: 2px; }
.mobile-dot     { color: #ccc; }

/* ── Draft cards ── */
.draft-card {
  position: relative; cursor: pointer;
  transition: all 0.18s ease; border: 1.5px solid transparent;
}
.draft-card:hover {
  box-shadow: 0 4px 12px rgba(45, 75, 149, 0.12);
  transform: translateY(-1px); border-color: #c5d3f0;
}
.draft-card--selected { border-color: #5e85ef !important; background: #f5f8ff; }

/* ── Badge en el share icon ── */
.share-badge {
  position: absolute;
  top: 0; right: 0;
  width: 14px; height: 14px;
  border-radius: 50%;
  background: #2D4B95;
  color: white;
  font-size: 8px;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  line-height: 1;
  pointer-events: none;
}
.share-badge--mobile { width: 12px; height: 12px; font-size: 7px; }

/* ── Share dropdown rediseñado ── */
.share-dropdown-card {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid #e8edf8;
}

.share-dropdown-header {
  display: flex;
  align-items: center;
  padding: 12px 14px 10px;
  background: linear-gradient(135deg, #f5f8ff 0%, #eef1fb 100%);
  border-bottom: 1px solid #e8edf8;
}
.share-dropdown-title {
  font-size: 12px;
  font-weight: 700;
  color: #2D4B95;
  letter-spacing: 0.3px;
}
.share-count-chip {
  background: #2D4B95 !important;
  color: white !important;
  font-weight: 700 !important;
  font-size: 10px !important;
  height: 18px !important;
}

.share-dropdown-body {
  padding: 10px 12px;
  max-height: 220px;
  overflow-y: auto;
}

.share-user-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fafbff;
  border: 1px solid #eef1fb;
  margin-bottom: 6px;
  transition: border-color 0.15s ease;
}
.share-user-item:last-child { margin-bottom: 0; }
.share-user-item:hover { border-color: #c5d3f0; }

.share-user-avatar {
  width: 32px; height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2D4B95, #5e85ef);
  color: white;
  font-size: 11px;
  font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.5px;
}
.share-user-avatar--sm { width: 26px; height: 26px; font-size: 9px; }

.share-user-info { flex: 1; min-width: 0; }
.share-user-name {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #2D4B95;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.share-user-email {
  margin: 0;
  font-size: 10px;
  color: #8898b3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.share-remove-btn {
  opacity: 0.4;
  transition: opacity 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}
.share-remove-btn:hover { opacity: 1; color: #e04f4f !important; }
.share-remove-btn .v-icon { color: #8898b3; transition: color 0.15s ease; }
.share-remove-btn:hover .v-icon { color: #e04f4f !important; }

.share-empty-state {
  display: flex; flex-direction: column; align-items: center;
  padding: 16px 8px; gap: 6px;
}
.share-empty-text {
  margin: 0;
  font-size: 11px;
  color: #aab4cc;
  font-style: italic;
}

.share-dropdown-footer {
  padding: 8px 12px 10px;
  border-top: 1px solid #eef1fb;
  background: #fafbff;
}
.share-add-btn {
  background: linear-gradient(135deg, #2D4B95, #4a6bc9) !important;
  color: white !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  box-shadow: 0 2px 8px rgba(45, 75, 149, 0.25) !important;
}
.share-add-btn:hover {
  box-shadow: 0 4px 12px rgba(45, 75, 149, 0.35) !important;
}
</style>